// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2ymwZN2Px{display:flex;max-width:100%;position:relative}._2ymwZN2Px ._4nbjpXGox{top:100%;left:0}._2ymwZN2Px ._40RsL1OAx{left:100%;top:0}._2ymwZN2Px ._1onAx2uLx{top:0}._2ymwZN2Px ._1onAx2uLx._40RsL1OAx{left:0}._2ymwZN2Px ._71xuMopqx{transform:translateY(-50%)}._2ymwZN2Px ._3t1lRMRXx{left:auto;right:0}._2ymwZN2Px ._3t1lRMRXx._40RsL1OAx{right:100%;left:auto}._2ymwZN2Px ._6ZHel6iCx{left:auto;right:auto}._2ymwZN2Px .kx8A48oBx{bottom:100%;top:auto}._2ymwZN2Px .kx8A48oBx._40RsL1OAx{bottom:0}._2ymwZN2Px .kx8A48oBx._1onAx2uLx{top:auto;bottom:0}._2ymwZN2Px .kx8A48oBx._3t1lRMRXx._40RsL1OAx{top:auto;bottom:0}\n", "",{"version":3,"sources":["webpack://client/shared/overlay-positioner/overlay-positioner.scss"],"names":[],"mappings":"AAAwmB,YAAY,YAAY,CAAC,cAAc,CAAC,iBAAiB,CAAC,wBAAwB,QAAQ,CAAC,MAAM,CAAC,wBAAwB,SAAS,CAAC,KAAK,CAAC,wBAAqB,KAAK,CAAC,mCAAgC,MAAM,CAAC,wBAAsB,0BAA0B,CAAC,wBAAmB,SAAS,CAAC,OAAO,CAAC,mCAA8B,UAAU,CAAC,SAAS,CAAC,wBAAsB,SAAS,CAAC,UAAU,CAAC,uBAAoB,WAAW,CAAC,QAAQ,CAAC,kCAA+B,QAAQ,CAAC,kCAA4B,QAAQ,CAAC,QAAQ,CAAC,6CAAqC,QAAQ,CAAC,QAAQ","sourcesContent":[":export{tabletScreen:768px;smallScreen:1100px;mediumScreen:1300px;largeScreen:1500px;azure:#006fc8;cyan:#1FAECE;primaryText:var(--primary-text);secondaryText:var(--secondary-text);chartGridColor:var(--ui-divider);gray10:#dedede;msDarkBlue:#002050;amberLight2:#F7E28B;violetLight2:#CEC0EC;tealLight3:#CFECE8;bannerBlue:var(--banner-blue);spaceXXS:4px;spaceXS:8px;spaceS:16px;spaceM:20px;spaceXM:24px;spaceL:32px;spaceXL:40px;spaceXXL:60px;panelSlideDuration:200ms;panelFadeDuration:100ms;ccBannerHeight:46px;chartCyan:var(--charts-cyan);chartMapBorders:var(--charts-map-border);chartMapBgDefault:var(--charts-map-bg)}.positioner{display:flex;max-width:100%;position:relative}.positioner .positioned{top:100%;left:0}.positioner .horizontal{left:100%;top:0}.positioner .overlap{top:0}.positioner .overlap.horizontal{left:0}.positioner .v-center{transform:translateY(-50%)}.positioner .right{left:auto;right:0}.positioner .right.horizontal{right:100%;left:auto}.positioner .h-center{left:auto;right:auto}.positioner .upward{bottom:100%;top:auto}.positioner .upward.horizontal{bottom:0}.positioner .upward.overlap{top:auto;bottom:0}.positioner .upward.right.horizontal{top:auto;bottom:0}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"positioner": "_2ymwZN2Px",
	"positioned": "_4nbjpXGox",
	"horizontal": "_40RsL1OAx",
	"overlap": "_1onAx2uLx",
	"v-center": "_71xuMopqx",
	"vCenter": "_71xuMopqx",
	"right": "_3t1lRMRXx",
	"h-center": "_6ZHel6iCx",
	"hCenter": "_6ZHel6iCx",
	"upward": "kx8A48oBx"
};
export default ___CSS_LOADER_EXPORT___;
